import React from 'react';
import { Button } from '@devsbb/ui';
import { useLogin } from './useLogin';

export const LocalDevAuthButton = () => {
  const { login } = useLogin();
  return (
    <Button onClick={login} variant="Primary">
      Login
    </Button>
  );
};
